(function () {
  function closeMobileSubmenus(currentItem) {
    document.querySelectorAll('.mobile-menu .menu-item-has-children.menu-open').forEach((item) => {
      if (item === currentItem) {
        return;
      }

      item.classList.remove('menu-open');

      const submenu = item.querySelector(':scope > .sub-menu');
      const toggle = item.querySelector(':scope > .submenu-toggle');

      if (submenu) {
        submenu.classList.remove('open');
      }

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function toggleMobileSubmenu(toggle) {
    const parentItem = toggle.closest('.menu-item-has-children');
    const submenu = parentItem ? parentItem.querySelector(':scope > .sub-menu') : null;

    if (!submenu) {
      return;
    }

    closeMobileSubmenus(parentItem);

    const shouldOpen = !parentItem.classList.contains('menu-open');

    parentItem.classList.toggle('menu-open', shouldOpen);
    submenu.classList.toggle('open', shouldOpen);
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  function ensureMobileSubmenuToggles() {
    document.querySelectorAll('.mobile-menu .menu-item-has-children').forEach((item, index) => {
      const link = item.querySelector(':scope > a');
      const submenu = item.querySelector(':scope > .sub-menu');

      if (!link || !submenu || item.querySelector(':scope > .submenu-toggle')) {
        return;
      }

      if (!submenu.id) {
        submenu.id = `mobile-submenu-${index}`;
      }

      const toggle = document.createElement('button');
      toggle.className = 'submenu-toggle';
      toggle.type = 'button';
      toggle.setAttribute('aria-label', 'Toggle submenu');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', submenu.id);

      link.insertAdjacentElement('afterend', toggle);
    });
  }

  function headerSubmenu() {
    ensureMobileSubmenuToggles();

    document.querySelectorAll('.header__menu .menu-item-has-children > a, .footer__menu .menu-item-has-children > a').forEach((link) => {
      link.setAttribute('aria-haspopup', 'true');
    });

    document.addEventListener('click', (event) => {
      const mobileToggle = event.target.closest('.mobile-menu .submenu-toggle');

      if (mobileToggle) {
        event.preventDefault();
        event.stopPropagation();
        toggleMobileSubmenu(mobileToggle);
        return;
      }

      if (event.target.closest('.mobile-menu .menu-item-has-children')) {
        return;
      }

      closeMobileSubmenus(null);
    });
  }

  document.addEventListener('DOMContentLoaded', headerSubmenu);
})();
